<template>
  <div class="form">
    <!-- <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <div class="container">
      <div class="form-container form-container--box">
        <label for="searchBy" class="w-100 text-left">Número de identificación:</label><br>
        <div class="d-flex justify-content-center">
          <div class="input-wrap w-100 mb-2">
            <input placeholder="Número de identificación" type="text" v-model="idDocument">
          </div>
        </div>
        <div class="d-flex input-wrap justify-content-center">
          <button @click="searchRequests()" class="app-btn w-100">Buscar</button>
        </div>
      </div>
    </div>

    <!-- Error Modal -->
    <div v-if="error != ''" class="error-modal">
      <div @click="error = ''" class="backdrop"></div>
      <div class="modal-box">
        <div class="app-icon mb-2">
          <v-icon name="exclamation-triangle" scale="2"/>
        </div>
        <div class="mb-4">
          {{error}}
        </div>
        <div>
          <button @click="error = ''" class="app-btn w-100">Continuar</button>
        </div>
      </div>
    </div>

    <!-- Screen Loader -->
    <div v-if="loading" class="screen-loader">
      <div class="spinner">
        <v-icon name="circle-notch" scale="3"/>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import {  mapActions, mapMutations } from 'vuex';

export default {
  data(){
    return {
      idDocument: '',
      error: '',
      loading: false
    }
  },
  methods: {
    searchRequests(){

      this.loading = true;

      if (this.idDocument == '') {
        this.error = 'Digita tu documento para consultar';
        return;
      }
      
      axios.get("externos/generate/applicantInfo/identification/" + this.idDocument)
      .then((result) => {

        this.loading = false;

        console.log("Result Request: ", result);

        this.setIdDocument(this.idDocument);

        this.$router.push('/userVerification');

      })
      .catch((e) => {
        this.loading = false;
        this.error = 'Se ha producido un error, intentelo de nuevo más tarde.'
      })
    },
    ...mapMutations({
      setIdDocument: 'setIdDocument'
    }),
  }
}
</script>


<style lang="scss">
.form {
  padding: 50px 0;
  .container {
    
  }
}
</style>